import { ACCEPTED_EXT } from '../model/constants'

export function isPdfFile(file: File): boolean {
  return file.name.toLowerCase().endsWith(ACCEPTED_EXT)
}
